import React, { useState } from 'react';
import '../App.css';
import Header from './Header';

function Pricing() {
    const [billingCycle, setBillingCycle] = useState('monthly');

    const toggleBillingCycle = (cycle) => {
        setBillingCycle(cycle);
    };

    return (
        <div className="pricing-page">
            <Header />
            
            <div className="pricing-container">
                <div className="pricing-header">
                    <h1>Pricing</h1>
                    <p className="pricing-subtitle">Choose the plan that works for you</p>
                    
                    <div className="billing-toggle">
                        <button 
                            className={`toggle-button ${billingCycle === 'monthly' ? 'active' : ''}`}
                            onClick={() => toggleBillingCycle('monthly')}
                        >
                            MONTHLY
                        </button>
                        <button 
                            className={`toggle-button ${billingCycle === 'yearly' ? 'active' : ''}`}
                            onClick={() => toggleBillingCycle('yearly')}
                        >
                            YEARLY (SAVE 20%)
                        </button>
                    </div>
                </div>
                
                <div className="pricing-plans">
                    <div className="pricing-plan">
                        <h3 className="plan-name">Hobby</h3>
                        <div className="plan-price">
                            <span className="price">Free</span>
                        </div>
                        <div className="plan-divider"></div>
                        <div className="plan-features">
                            <h4>Includes</h4>
                            <ul>
                                <li>Pro two-week trial</li>
                                <li>2000 completions</li>
                                <li>50 slow premium requests</li>
                            </ul>
                        </div>
                        <div className="plan-cta">
                            <button className="download-button">
                                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="7 10 12 15 17 10"></polyline>
                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                </svg>
                                DOWNLOAD
                            </button>
                            <button className="others-button">OTHERS</button>
                        </div>
                    </div>
                    
                    <div className="pricing-plan featured">
                        <h3 className="plan-name">Pro</h3>
                        <div className="plan-price">
                            <span className="price">${billingCycle === 'monthly' ? '20' : '16'}</span>
                            <span className="billing-period">/{billingCycle === 'monthly' ? 'month' : 'month (billed annually)'}</span>
                        </div>
                        <div className="plan-divider"></div>
                        <div className="plan-features">
                            <h4>Everything in Hobby, plus</h4>
                            <ul>
                                <li>Unlimited completions</li>
                                <li>500 fast premium requests per month</li>
                                <li>Unlimited slow premium requests</li>
                                <li>10 o1-mini uses per day</li>
                            </ul>
                        </div>
                        <div className="plan-cta">
                            <button className="get-started-button">GET STARTED</button>
                        </div>
                    </div>
                    
                    <div className="pricing-plan">
                        <h3 className="plan-name">Business</h3>
                        <div className="plan-price">
                            <span className="price">${billingCycle === 'monthly' ? '40' : '32'}</span>
                            <span className="billing-period">/user/month</span>
                        </div>
                        <div className="plan-divider"></div>
                        <div className="plan-features">
                            <h4>Everything in Pro, plus</h4>
                            <ul>
                                <li>Enforce privacy mode org-wide</li>
                                <li>Centralized team billing</li>
                                <li>Admin dashboard with usage stats</li>
                                <li>SAML/OIDC SSO</li>
                            </ul>
                        </div>
                        <div className="plan-cta">
                            <button className="get-started-button">GET STARTED</button>
                        </div>
                    </div>
                </div>
                
                <div className="demo-section">
                    <button className="demo-button">Schedule a Demo</button>
                </div>
                
                <div className="pricing-footer">
                    <h2>Enterprise solutions available</h2>
                    <p>Contact us for custom pricing and implementation for larger organizations.</p>
                    <p>All plans include our core assessment technology and candidate matching algorithm.</p>
                </div>
            </div>
        </div>
    );
}

export default Pricing;
